import React, { useState } from 'react';
import phone from './../assets/images/phone.png';
import downloadPlayStoreFr from './../assets/images/google-play-neatcar.png';
import downloadAppStoreFr from './../assets/images/app-store-neatcar.png';
import downloadPlayStoreEn from './../assets/images/google-play-neatcar-en.png';
import downloadAppStoreEn from './../assets/images/app-store-neatcar-en.png';
import { useTranslation } from "react-i18next";
import NeatcarButton from "./NeatcarButton";
import DownloadAppModal from "./DownloadAppModal";

export const BOTTOM_BANNER_HEIGHT = 60;

const DownloadBanner = () => {
  const [downloadAppModalOpen, setDownloadAppModalOpen] = useState(false);
  const { i18n, t } = useTranslation('common');

  return (
    <div className="static bottom-0 bg-white flex flex-1 items-center px-3 sm:px-6 gap-x-2 sm:gap-x-4 z-0" style={{height: `${BOTTOM_BANNER_HEIGHT}px`}}>
      <DownloadAppModal open={downloadAppModalOpen} onClose={() => setDownloadAppModalOpen(false)}/>
      <a 
        href={i18n.language === 'fr' ? 'https://neatcar.com/ca/fr' : 'https://neatcar.com/ca'} 
        className="flex flex-row items-center gap-x-2 sm:gap-x-4 no-underline hover:opacity-80 transition-opacity"
        aria-label="Visit Neatcar website"
      >
        <div className="relative" style={{ height: '36px', width: '36px' }}>
          <img 
            src="https://play-lh.googleusercontent.com/a9dUWy2zxPzEFebKgoqlrEIsBdisQuhGaNvQrMYoQGDPuEz24C_JIcDruFCZjXyUA1sh=w240-h480-rw" 
            srcSet="https://play-lh.googleusercontent.com/a9dUWy2zxPzEFebKgoqlrEIsBdisQuhGaNvQrMYoQGDPuEz24C_JIcDruFCZjXyUA1sh=w480-h960-rw 2x"
            alt=""
            aria-hidden="true"
            width={'36'} 
            height={'36'} 
            loading="eager" 
            className="w-9 h-9 rounded-lg absolute left-0 opacity-40"
            style={{ 
              top: '4px',
              filter: 'blur(8px)',
              WebkitMaskImage: 'linear-gradient(to bottom, transparent 0%, rgba(0,0,0,0.3) 30%, rgba(0,0,0,0.7) 50%, black 70%)',
              maskImage: 'linear-gradient(to bottom, transparent 0%, rgba(0,0,0,0.3) 30%, rgba(0,0,0,0.7) 50%, black 70%)'
            }}
          />
          <img 
            src="https://play-lh.googleusercontent.com/a9dUWy2zxPzEFebKgoqlrEIsBdisQuhGaNvQrMYoQGDPuEz24C_JIcDruFCZjXyUA1sh=w240-h480-rw" 
            srcSet="https://play-lh.googleusercontent.com/a9dUWy2zxPzEFebKgoqlrEIsBdisQuhGaNvQrMYoQGDPuEz24C_JIcDruFCZjXyUA1sh=w480-h960-rw 2x"
            alt={'Neatcar'} 
            width={'36'} 
            height={'36'} 
            loading="eager" 
            className="w-9 h-9 rounded-lg relative z-10" 
          />
        </div>
        <div className="flex flex-col items-start">
          <h1 className="text-neatcar font-bold text-xs sm:text-sm leading-none">Neatcar</h1>
          <div className="text-neatcarGray font-bold text-xs leading-none hidden sm:block">{t('buyFromPhone')}</div>
        </div>
      </a>
      <div className="flex-1"></div>
      <div className="hidden sm:block">
        <NeatcarButton title={t('sendToPhone')} icon={phone} gray onClick={() => setDownloadAppModalOpen(true)}/>
      </div>
      <a href={t('playStoreLink')} target={'_blank'} rel="noreferrer" className="sm:hidden">
        <img src={i18n.language === 'fr' ? downloadPlayStoreFr : downloadPlayStoreEn} width={'100'} height={'34'} fetchpriority="high" alt={'Download on Google Play Store'} className="h-8 rounded-md" />
      </a>
      <a href={t('appStoreLink')} target={'_blank'} rel="noreferrer" className="sm:hidden">
        <img src={i18n.language === 'fr' ? downloadAppStoreFr : downloadAppStoreEn} width={'100'} height={'34'} fetchpriority="high" alt={'Download on Apple App Store'} className="h-8 rounded-md" />
      </a>
      <a href={t('playStoreLink')} target={'_blank'} rel="noreferrer" className="hidden md:block">
        <img src={i18n.language === 'fr' ? downloadPlayStoreFr : downloadPlayStoreEn} width={'100'} height={'34'} fetchpriority="high" alt={'Download on Google Play Store'} className="rounded-md" />
      </a>
      <a href={t('appStoreLink')} target={'_blank'} rel="noreferrer" className="hidden md:block">
        <img src={i18n.language === 'fr' ? downloadAppStoreFr : downloadAppStoreEn} width={'100'} height={'34'} fetchpriority="high" alt={'Download on Apple App Store'} className="rounded-md" />
      </a>
    </div>
  )
}

export default DownloadBanner;
